import { Injectable } from '@angular/core';
import { Http, Response } from "@angular/http";
import { base_url, serverPort } from "../../../server/src/config/config";
import { LoaderService } from "./loader.service";
import { Router } from "@angular/router";

@Injectable()
export class AuthenticationService {
  constructor(private http: Http, private loaderService: LoaderService, private router: Router) {
  }

  login(email: string, password: string) {
    //noinspection TypeScriptValidateTypes
    return this.http.post(`${base_url}/v1/users/login`, {
      email: email,
      password: password
    }).map((response: Response) => {
      // login successful if there's a jwt token in the response
      let user = response.json();
      if (user) {
        // store user details and jwt token in local storage to keep user logged in between page refreshes
        localStorage.setItem('currentUser', JSON.stringify(user));
      }
    });
  }

  user() {
    return localStorage.getItem('currentUser') ? JSON.parse(localStorage.getItem('currentUser')) : null;
  }

  logout() {
    // remove user from local storage to log user out
    localStorage.removeItem('currentUser');
    this.loaderService.loading(true);
    this.router.navigateByUrl('/login');
  }
}



// WEBPACK FOOTER //
// /root/production/sne-pro/src/app/services/authentication.service.ts